/**
 * Admin page breadcrumb trail, e.g. Dashboard › Recording › Participant.
 * Every item but the last is a link.
 */
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="ja-label ja-breadcrumbs">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <Fragment key={`${it.label}-${i}`}>
            {i > 0 && <span aria-hidden="true" className="ja-breadcrumbs-sep">&rsaquo;</span>}
            {last || !it.to
              ? <span aria-current={last ? 'page' : undefined} className={last ? 'ja-breadcrumbs-current' : undefined}>{it.label}</span>
              : <Link to={it.to}>{it.label}</Link>}
          </Fragment>
        );
      })}
    </nav>
  );
}

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string.isRequired, to: PropTypes.string })).isRequired,
};
